/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from "react";
import { connect } from "react-redux";
// import { Accordion, Card } from "react-bootstrap";
// import _ from "lodash";
// import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
// import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { getOrganisationActivities } from "actions";
import ActivitiesTable from "components/organisationActivities/ActivitiesTable";
// import { OrangeAlert, NavyBlueAlert } from "components/elements/alerts";
import "components/organisationActivities/organisationActivities.css";
import { Trans } from "react-i18next";
import i18n from "i18next";

// const mobileCategoryListVisibleStyle = { visibility: "visible", opacity: "1" };
// const mobileCategoryListInVisibleStyle = { visibility: "hidden", opacity: "0" };
class OrganisationActivities extends Component {
  state = {
    activitiesFetched: false,
    showOptions: false,
    filteredActivitiesData: [],
    filterTerm: "",
    error: null,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.props.getOrganisationActivities(
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  componentDidUpdate = (prevProps, prevState) => {

    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredActivitiesData: this.props.organisationActivities.data.data.activities.filter(
          (activity) => {
            return activity.employee.name
              .toLowerCase()
              .includes(this.state.filterTerm.toLowerCase());
          }
        ),
      });
    }
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onSuccess = () => {

    this.props.onProcessEnd();

    this.setState({
      activitiesFetched: true,
      filteredActivitiesData: this.props.organisationActivities.data.data
        .activities,
    });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  renderTableToolbar = () => {
    return (
      <div className="row align-items-center py-3 eduTitleArea">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="row">
            <div className="col-xs-0 col-sm-0 col-md-10 col-lg-10 tableSearchArea"></div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 tableSearchArea">
              <div className="inner-addon right-addon">
                <span className="iconmford fo-icon-search"></span>
                <input
                  type="text"
                  name="tableSearch"
                  id="tableSearch"
                  className="form-control"
                  placeholder={i18n.t("10053")}
                  onChange={(e) => this.handleFilter(e)}
                  value={this.state.filterTerm}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    if (!this.state.activitiesFetched) {
      return this.props.spinner;
    }

    return (
      <section className="sssArea my-3">
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>

                </li>
                <li>
                  <a href="#" style={{ verticalAlign: "middle" }}>
                    <Trans desc="Şirket Bilgileri">10024</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Organizasyon Değişimleri">10029</Trans>
                </li>
              </ul>
            </div>
          </div>
          {this.renderTableToolbar()}

          <div className="row py-4 bottomRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ActivitiesTable data={this.state.filteredActivitiesData} />
              {/* {console.log(this.props.activities.data.activities)} */}
            </div>
          </div>
          {/* <div className="row py-4 bottomRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">pager</div>
          </div> */}
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({ organisationActivities, application }) => {
  return {
    organisationActivities,
    application,
  };
};

export default connect(mapStateToProps, { getOrganisationActivities })(
  containsLongRunningProcess(requireAuth(OrganisationActivities))
);
